// @ts-nocheck
import * as addPanel from '@/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['add_section_label_site_search'],
      sections: [
        addPanel.sections.getSections().developer.searchBoxSection.getSection(),
      ],
    };
  },
};
